jQuery(document).ready(function ($) {
	$('.wp-block-plune-blocks-carousel-full .wp-block-columns').each(function() {
		const $columns = $(this);
		const $block = $columns.closest('.wp-block-plune-blocks-carousel-full');
		const showDots = $block.data('show-dots');
		const showArrows = $block.data('show-arrows');
		const loop = $block.data('loop');

		$columns.addClass('owl-carousel').owlCarousel({
			loop: loop,
			margin: 26,
			nav: showArrows,
			dots: showDots,
			startPosition: 1,
			navText: ['<i class="fa-regular fa-arrow-left"></i>', '<i class="fa-regular fa-arrow-right"></i>'],
			responsive: {
				0: {
					items: 1,
					stagePadding: 70,
				},
				770: {
					items: 3,
					stagePadding: 170,
				},
				1026: {
					items: 4,
					stagePadding: 170,
				},
				1441: {
					items: 4,
					stagePadding: 200,
				},
				1681: {
					items: 6,
					stagePadding: 280,
				}
			},
			onInitialized: function(event) {
				const $owlNav = $columns.find('.owl-nav');
				const $owlDots = $columns.find('.owl-dots');

				if (showArrows) {
					$owlNav.removeClass('disabled');
				}

				if (showDots) {
					$owlDots.removeClass('disabled');
				}
			},
			onTranslated: function(event) {
				const $owlNav = $columns.find('.owl-nav');
				const $owlDots = $columns.find('.owl-dots');

				if (showArrows) {
					$owlNav.removeClass('disabled');
				}

				if (showDots) {
					$owlDots.removeClass('disabled');
				}
			}
		});

		// Fancybox logic
		if ($block.data('fancybox-enabled')) {
			$columns.find('a[href]').each(function() {
				const imageSrc = $(this).attr('href');
				$(this).attr('data-fancybox', 'gallery');
				$(this).attr('href', imageSrc);
			});
		}
	});
});
